module.exports = __webpack_public_path__ + "static/img/gb-wls.c488ecae.svg";